import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

import { generateDocumentTitle } from "../../constants/document-title.ts"
import MapTab from "./MapTab.tsx"

// `GlobalMapHeader` (title/subtitle/tabs) is rendered from inside `MapTab`
// now, not as a page-level sibling — the mockup's own address-search box
// sits above the "Global Map" title, and that search's state/handlers
// (recentering the camera) live entirely inside `MapTab`'s hooks, so
// `MapTab` needs to control the ordering of "search, then header, then the
// rest" itself rather than this page interleaving two separate components.
const GlobalMapPage = () => {
  const { t } = useTranslation()

  useEffect(() => {
    generateDocumentTitle(t("globalMap.header.title"))
  }, [t])

  return (
    <div className="flex h-full w-full flex-col gap-4 bg-[#F1F5F9] px-6 py-5">
      <MapTab />
    </div>
  )
}

export default GlobalMapPage
